import { React, useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Push from "push.js";
import { Icon } from "@iconify/react";

import {
  Button,
  Fade,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Slide,
  Snackbar,
  Tooltip,
} from "@mui/material";

import useWindowDimensions from "../Hooks/useWindowDimensions";
// import CampaignIcon from "@mui/icons-material/Campaign";
// import ChatIcon from "@mui/icons-material/Chat";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { AES, enc } from "crypto-js";
import moment from "moment";
import io from "socket.io-client";
import "./Chat.css";
import CallControl from "./CallControl";
import CallPermissionModal from "./CallPermissionModal";
import ChatList from "./ChatList";
import ChatRoom from "./ChatRoom";
import ChatRoomOld from "./ChatRoomOld";
// import ChatRoomFB from "./ChatRoomFB";
import ContinueAutoDial from "./ContinueAutoDial";
import LandingChat from "./LandingChat";
import NewChat from "./NewChat";
// import ScrollList from "./ScrollList";

import CallHistory from "../CallHistory/CallHistory";
import Campaign from "../Campaign/Campaign";
import CallOverlay from "../Components/CallOverlay";
import Contact from "../Contact/Contact";
import Dashboard from "../Dashboard/Dashboard";
import DashboardInteraction from "../Dashboard/DashboardInteraction";
import DashboardOutbound from "../Dashboard/DashboardOutbound";
import DashboardSocmed from "../Dashboard/DashboardSocmed";
import DashboardTicket from "../Dashboard/DashboardTicket";
import DashboardTSS from "../Dashboard/DashboardTSS";
import DashboardWhatsapp from "../Dashboard/DashboardWhatsapp";
import DashboardWhatsappInsights from "../Dashboard/DashboardWhatsappInsights";
import { ErrorBoundary } from "../ErrorBoundary";
import useTabActive from "../Hooks/useTabActive";
import NotificationSound from "../Images/Notification.wav";
import Ringtone from "../Images/Ringtone.wav";
import LogoMoxcal32 from "../Images/XOnly32.png";
import Monitoring from "../Monitoring/Monitoring";
import Navbarbar from "../Navbar/Navbarbar";
import QualityAssurance from "../QA/QualityAssurance";
import Email from "../Email/Email";

import {
  stateAction,
  agentState,
  userLogout,
} from "../Store/Actions/AuthAction";

import { addScreenRecording, answerCall, getACDISPlan, getRecording } from "../Store/Actions/CallAction";

import {
  chatList,
  endChat,
  messageList,
  readchat,
  sendChat,
  getFileMedia,
  getCountList,
  setAssignedAgent,
} from "../Store/Actions/ChatAction";

import {
  clearSessionCall,
  holdCall,
  muteCall,
  registerSIP,
  unregisterSIP,
} from "../Store/SIP/call";

import {
  RESET_AGENT_STATE,
  SET_AUTO_DIAL,
  SET_CALL_SCHEDULE_ASSIGNMENT_ID,
  SET_DIAL_MODE,
  SET_IS_SELECTING_CONTACT,
  SET_PENDING_STATUS_REASON,
} from "../Store/Types/AgentTypes";

import {
  ERROR_CLEARALL,
  SET_LOGOUT_CLEAR,
  SUCCESS_MESSAGE_CLEAR,
} from "../Store/Types/AuthTypes";

import {
  CHECK_STRAY_CALL,
  END_ACW,
  INCOMING_CALL,
  RESET_CALL_STATE,
  SET_GO_TO_ACW,
  SET_IS_IN_CALL,
  SET_SCREEN_REC_FILENAME,
  SET_TRANSFER_COUNT,
  START_CALL,
  UPDATE_CALL_STATE,
  UPDATE_STATECALL,
  UPDATE_STATECALL_RECEIVED_DATE,
  WAITING_CALL,
} from "../Store/Types/CallTypes";

import {
  SORT_CHATLIST,
  CLEAR_CHATLIST,
  SET_ERROR_CLEAR,
  SET_SUCCESS_CLEAR,
  CLEAR_MESSAGE,
  SET_NEWSTATUS,
  RECEIVE_CHAT,
  CLEAR_CHATSTATE,
  ENDCHAT_AUTO,
  ENDCHAT_SUCCESS,
  ENDASSIGNED_SUCCESS,
  UPDATE_CHAT,
  UPDATE_CHAT_SINGLE,
  UPDATE_EMAIL,
} from "../Store/Types/ChatTypes";

import Telemarketing from "../Telemarketing/Telemarketing";
import Ticket from "../Ticket/Ticket";
import NotificationPage from "../Notification/Notification";
import BroadcastContact from "../Contact/BroadcastContact";
import ExtractSales from "../ExtractSales/ExtractSales";
import FieldCollection from "../FieldCollection/FieldCollection";
import Production from "../Production/Production";
import { uploadScreenRecording } from "../Store/Actions/OutboundAction";
import { GET_ASSIGNMENT_DETAILS, SET_CURRENT_ASSIGNMENT_ID } from "../Store/Types/OutboundTypes";
import {
  TICKET_CREATED,
  TICKET_ESCALATED,
  TICKET_MERGED,
} from "../Store/Types/SocketTypes";
import { SET_SELECTED_TICKET_CASE_ID, SET_TABLE_PAGE } from "../Store/Types/TicketTypes";
import { CallEnd, Mic, MicOff, PhonePaused } from "@mui/icons-material";

const slideTransition = (props) => {
  return <Slide {...props} direction="left" />;
};
const ringtone = new Audio(Ringtone);
ringtone.loop = true;
const ping = new Audio(NotificationSound);

export default function Chat() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const localVideoRef = useRef(null);
  const localMediaStreamRef = useRef(null);
  const remoteAudioRef = useRef(null);
  const remoteVideoRef = useRef(null);
  const recordingCanvasRef = useRef(null);
  const recordingAnimationFrameRef = useRef(null);
  const { width } = useWindowDimensions();

  const {
    myInfo,
    CurrentState,
    CurrentColor,
    errorMessageAuth,
    successMessageAuth,
    sipAccount,
    sipParam,
  } = useSelector((state) => state.auth);

  const {
    contact,
    max,
    page,
    Mpage,
    Mmax,
    errorMessage,
    successMessage,
    message,
    detailchat,
    plChatListID,
    chatListViewType,
    emitCode,
    notReadCountNav,
    isEmpty,
  } = useSelector((state) => state.chat);

  const {
    ACDDeviceName,
    callWaiting,
    ext,
    inAppCallStatus,
    inAppCallType,
    isMuted,
    onHold,
    phoneNumber,
    phoneTypeID,
    queueName,
    type,
    screenRecFilename,
    isContinueTransfer,
    stateCall,
    transferCount,
  } = useSelector((state) => state.call);

  const { isInAutoDial } = useSelector((state) => state.agent);
  const app = localStorage.getItem("app");

  const isApp = () => {
    return app ? true : false;
  };

  const [isBack, setIsBack] = useState(false);
  const level = myInfo.user.Level;
  const [openModal, setOpenModal] = useState(false);
  const [selectedChat, setSelectedChat] = useState(null);
  const [active, setActive] = useState(level > 0 ? 1 : 0);

  const [pageLocation, setPageLocation] = useState(
    isApp()
      ? "chat"
      : window.localStorage.getItem("winPage")
      ? window.localStorage.getItem("winPage")
      : null
  );
  const [hasMore, sethasMore] = useState(true);
  const [mhasMore, setmhasMore] = useState(true);
  const [viewType, setviewType] = useState("active");
  const initialPageLoaded = useRef(false);
  const [childKey, SetChildKey] = useState("");
  const [mKey, SetmKey] = useState("");
  const [activeChat, setActiveChat] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElMore, setAnchorElMore] = useState(null);
  const [renderChat, setRenderChat] = useState(false);
  const [footerMsg, setFooterMsg] = useState("");
  const [file64, setFile64] = useState({
    name: null,
    base64: null,
    type: null,
  });

  const [isCallComing, setIsCallComing] = useState(false);
  const [isCallWaiting, setIsCallWaiting] = useState(false);
  const [isTransferCallComing, setIsTransferCallComing] = useState(false);
  const [chatSource, setChatSource] = useState("");
  const [isBroadcastContactShown, setIsBroadcastContactShown] = useState(false);
  const [screenRecBlob, setScreenRecBlob] = useState(null);
  const [openModalCallPermission, setOpenModalCallPermission] = useState(false);

  // Used on WABA chat when sending a call permission request
  const [isSendingCallPermissionRequest, setIsSendingCallPermissionRequest] =
    useState(false);

  // Used for typing indicator animation
  const [isTyping, setIsTyping] = useState(false);

  // For sending new chat
  const [isFromNewChatButton, setIsFromNewChatButton] = useState(false);

  // For assigning multiple chats
  const [isAssigningChats, setIsAssigningChats] = useState(false);

  const [isVideoCallMinimized, setIsVideoCallMinimized] = useState(false);
  const [scaleClass, setScaleClass] = useState("");
  const open = Boolean(anchorEl);
  const openMore = Boolean(anchorElMore);
  const socket = useRef();

  //msgParam to be used for sending message in NewChat.js and ChatRoom.js
  const [msgParam] = useState({
    contactname: "",
    number: "",
    session: "dev1", // Temp hardcoded
    type: "chat",
    message: "",
    caption: "",
    newchat: false,
    filename: "",
    curChatID: 0,
  });

  // Check if tab/window is active
  const isTabActive = useTabActive();

  // Anti refresh
  const alertUser = (event) => {
    if (!localStorage.getItem("bypassAntiRefresh")) {
      event.preventDefault();
      event.returnValue = ""; // Empty string to show the browser's default confirmation message
    }
  };

  function saveRecordingLocally(blob) {
    console.log("saving recording locally...");
    const downloadUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = `backup-screen-recording-${moment().format("YYYY-MM-DD-HH-mm-ss")}.webm`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(downloadUrl), 1000);
  }

  useEffect(() => {
    const detectScale = () => {
      const ratio = window.devicePixelRatio || 1;
      const rounded = Math.round(ratio * 100) / 100;

      if (Math.abs(rounded - 1.25) < 0.01) {
        setScaleClass("scale-125");
      } else if (Math.abs(rounded - 1.5) < 0.01) {
        setScaleClass("scale-150");
      } else {
        setScaleClass("");
      }
    };

    detectScale();
    window.addEventListener("resize", detectScale);

    return () => {
      window.removeEventListener("resize", detectScale);
    };
  }, []);

  useEffect(() => {
    window.addEventListener("beforeunload", alertUser);

    return () => {
      window.removeEventListener("beforeunload", alertUser);
    };
  }, []);

  useEffect(() => {
    if (localStorage.getItem("ongoingCall")) {
      let ongoingCall = JSON.parse(localStorage.getItem("ongoingCall"));
    }
  }, []);

  // useEffect(() => {
  //   let mediaRecorder,
  //     screenCaptureStream;

  //   if (type === "inbound" && inAppCallType === "video") {
  //     /* navigator.mediaDevices
  //       .getUserMedia({ audio: true, video: true })
  //       .then((stream) => {
  //         localVideoStream = stream;

  //         if (localVideoRef.current) {
  //           localVideoRef.current.srcObject = stream;
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error accessing local media:", error);
  //       }); */

  //     const displayMediaOptions = {
  //       video: {
  //         displaySurface: "monitor",
  //         frameRate: { ideal: 10, max: 15 },
  //         height: { max: 720 },
  //         width: { max: 1280 },
  //       },

  //       preferCurrentTab: false,
  //       selfBrowserSurface: "exclude",
  //       surfaceSwitching: "exclude",
  //       monitorTypeSurfaces: "include",
  //     };

  //     navigator.mediaDevices
  //       .getDisplayMedia(displayMediaOptions)
  //       .then((stream) => {
  //         const audioContext = new AudioContext(),
  //           audioDestination = audioContext.createMediaStreamDestination(),
  //           localStream = localMediaStreamRef.current,
  //           recordedChunks = [];

  //         screenCaptureStream = stream;

  //         // Connect local audio
  //         const localAudioSource = audioContext.createMediaStreamSource(localStream);
  //         localAudioSource.connect(audioDestination);

  //         // Connect remote audio
  //         const remoteStream = remoteAudioRef.current?.srcObject;

  //         if (remoteStream) {
  //           const remoteAudioSource = audioContext.createMediaStreamSource(remoteStream);
  //           remoteAudioSource.connect(audioDestination);
  //         }

  //         // Combine video with mixed audio
  //         const combinedStream = new MediaStream([
  //           ...stream.getVideoTracks(), // screen capture
  //           ...audioDestination.stream.getAudioTracks(), // mixed audio
  //         ]);

  //         mediaRecorder = new MediaRecorder(combinedStream, {
  //           mimeType: "video/webm; codecs=vp9",
  //         });

  //         mediaRecorder.ondataavailable = (event) => {
  //           if (event.data.size > 0) {
  //             recordedChunks.push(event.data);

  //             setScreenRecBlob(
  //               new Blob(recordedChunks, { type: "video/webm" })
  //             );
  //           }
  //         };

  //         mediaRecorder.start();
  //       })
  //       .catch((error) => {
  //         console.error("Error accessing display media:", error);
  //       });
  //   }

  //   return () => {
  //     mediaRecorder?.stop();
  //     // localVideoStream?.getTracks().forEach((track) => track.stop());
  //     screenCaptureStream?.getTracks().forEach((track) => track.stop());
  //   };
  // }, [type, inAppCallType]);

  useEffect(() => {
    let mediaRecorder;
    let audioContext;
    let audioDestination;
    let recordedChunks = [];
    let recordingDataTimeout;

    const drawCover = (context, video, x, y, width, height) => {
      if (!video || video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) {
        return;
      }

      const videoWidth = video.videoWidth;
      const videoHeight = video.videoHeight;

      if (!videoWidth || !videoHeight) return;

      const videoRatio = videoWidth / videoHeight;
      const targetRatio = width / height;

      let sourceX = 0;
      let sourceY = 0;
      let sourceWidth = videoWidth;
      let sourceHeight = videoHeight;

      if (videoRatio > targetRatio) {
        sourceWidth = videoHeight * targetRatio;
        sourceX = (videoWidth - sourceWidth) / 2;
      } else if (videoRatio < targetRatio) {
        sourceHeight = videoWidth / targetRatio;
        sourceY = (videoHeight - sourceHeight) / 2;
      }

      context.drawImage(
        video,
        sourceX,
        sourceY,
        sourceWidth,
        sourceHeight,
        x,
        y,
        width,
        height
      );
    };

    const drawFrame = () => {
      const canvas = recordingCanvasRef.current;
      const remoteVideo = remoteVideoRef.current;
      const localVideo = localVideoRef.current;

      if (!canvas || !remoteVideo || !localVideo) return;

      const context = canvas.getContext("2d");

      context.fillStyle = "#000";
      context.fillRect(0, 0, canvas.width, canvas.height);

      // Customer video fills the recording.
      drawCover(context, remoteVideo, 0, 0, canvas.width, canvas.height);

      // Agent video appears as a top-right picture-in-picture overlay.
      const agentWidth = 160;
      const agentHeight = 120;
      const agentX = canvas.width - agentWidth - 16;
      const agentY = 16;

      context.save();

      context.beginPath();
      context.roundRect(agentX, agentY, agentWidth, agentHeight, 18);
      context.clip();

      drawCover(context, localVideo, agentX, agentY, agentWidth, agentHeight);

      context.restore();

      recordingAnimationFrameRef.current = requestAnimationFrame(drawFrame);
    };

    const startRecording = async () => {
      const remoteVideo = remoteVideoRef.current;
      const localVideo = localVideoRef.current;
      const localStream = localMediaStreamRef.current;
      const remoteStream = remoteAudioRef.current?.srcObject;

      if (!remoteVideo || !localVideo || !localStream) {
        toast.warn(
          "Screen recording could not start: media streams are unavailable.",
          { autoClose: false }
        );

        console.warn("Video recording streams are not ready");
        return;
      }

      try {
        const canvas = document.createElement("canvas");
        canvas.height = 640;
        canvas.width = 360;
        recordingCanvasRef.current = canvas;
        audioContext = new AudioContext();
        audioDestination = audioContext.createMediaStreamDestination();

        // Add the agent's audio.
        if (localStream.getAudioTracks().length > 0) {
          const localAudioSource =
            audioContext.createMediaStreamSource(localStream);

          localAudioSource.connect(audioDestination);
        }

        // Add the customer's audio.
        if (remoteStream?.getAudioTracks?.().length > 0) {
          const remoteAudioSource =
            audioContext.createMediaStreamSource(remoteStream);

          remoteAudioSource.connect(audioDestination);
        }

        drawFrame();
        const canvasStream = canvas.captureStream(15);

        audioDestination.stream.getAudioTracks().forEach((track) => {
          canvasStream.addTrack(track);
        });

        const mimeType = MediaRecorder.isTypeSupported(
          "video/webm;codecs=vp9,opus"
        )
          ? "video/webm;codecs=vp9,opus"
          : "video/webm";

        mediaRecorder = new MediaRecorder(canvasStream, {
          mimeType,
        });

        mediaRecorder.onstart = () => {
          console.log("Screen recording started");
          toast.info("Screen recording started.", { autoClose: 5000 });

          recordingDataTimeout = setTimeout(() => {
            if (recordedChunks.length === 0) {
              toast.warn(
                "Screen recording started but is not receiving media data.",
                { autoClose: false }
              );

              console.warn("MediaRecorder produced no data after starting");
            }
          }, 5000);
        };

        mediaRecorder.onerror = (event) => {
          toast.warn("Screen recording encountered a media error.", {
            autoClose: false,
          });

          console.error("MediaRecorder error:", event.error || event);
        };

        mediaRecorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            recordedChunks.push(event.data);
            clearTimeout(recordingDataTimeout);
          }
        };

        mediaRecorder.onstop = () => {
          console.log("Screen recording stopped.");

          if (recordedChunks.length === 0) {
            toast.warn("Screen recording stopped without receiving any data.", {
              autoClose: false,
            });

            console.warn("No recorded chunks were received");
            return;
          }

          const blob = new Blob(recordedChunks, {
            type: mediaRecorder.mimeType || "video/webm",
          });

          if (blob.size === 0) {
            toast.warn("Screen recording produced an empty file.", {
              autoClose: false,
            });

            console.warn("Recorded blob is empty");
            return;
          }

          console.log("Screen recording blob: ", blob);
          saveRecordingLocally(blob, screenRecFilename);
          setScreenRecBlob(blob);
          recordedChunks = [];
        };

        mediaRecorder.start(1000);

        if (mediaRecorder.state !== "recording") {
          toast.warn("Screen recording did not start.", {
            autoClose: false,
          });

          console.warn("Unexpected MediaRecorder state:", mediaRecorder.state);
        }
      } catch (error) {
        toast.warn("Unable to start screen recording.", {
          autoClose: false,
        });

        console.error("Screen recording initialization failed:", error);
      }
    };

    console.log("run effect. type: ", type, "inAppCallType: ", inAppCallType);

    if (type?.toLowerCase() === "inbound" && inAppCallType === "video") {
      const waitForVideo = setInterval(() => {
        const remoteReady =
          remoteVideoRef.current?.readyState >=
          HTMLMediaElement.HAVE_CURRENT_DATA;

        const localReady =
          localVideoRef.current?.readyState >=
          HTMLMediaElement.HAVE_CURRENT_DATA;

        if (remoteReady && localReady && localMediaStreamRef.current) {
          clearInterval(waitForVideo);
          startRecording();
        }
      }, 250);

      return () => {
        console.log("run return. state: ", mediaRecorder?.state)
        clearInterval(waitForVideo);
        clearTimeout(recordingDataTimeout);

        if (mediaRecorder?.state === "recording") {
          mediaRecorder.stop();
        }

        if (recordingAnimationFrameRef.current) {
          cancelAnimationFrame(recordingAnimationFrameRef.current);
        }

        audioContext?.close();
        recordingCanvasRef.current = null;
      };
    }

    return undefined;
  }, [type, inAppCallType]);

  /* useEffect(() => {
    if (screenRecBlob) {
      toast.info("uploading screen recording...", { autoClose: 3000 });
      const formData = new FormData();
      formData.append("files", screenRecBlob, screenRecFilename);

      uploadScreenRecording(formData)
        .then((response) => {
          if (response.status) {
            console.log("screen recording uploaded");
          } else {
            console.log("error", response.error);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });

      const now = moment();
      const year = now.format("YYYY");
      const month = now.format("MM");
      const date = now.format("DD");

      addScreenRecording({
        uniqueid: screenRecFilename
          .replace("scr_rec_", "")
          .replace(".webm", ""),

        screenrecmessageid: `${year}/${month}/${date}/${screenRecFilename}`,
      })
        .then((response) => {
          if (response.status) {
            toast.success("screen recording uploaded", {
              autoClose: 3000,
            });
          } else {
            console.log("error", response.error);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  }, [screenRecBlob]); */

  useEffect(() => {
    console.log(
      "screenRecBlob: ",
      screenRecBlob,
      "screenRecFilename: ",
      screenRecFilename
    );

    if (!screenRecBlob || !screenRecFilename) return;
    // saveRecordingLocally(screenRecBlob, screenRecFilename);

    const uploadRecording = async () => {
      toast.info("uploading screen recording...", { autoClose: false });
      const formData = new FormData();

      const uploadFilename =
        Number(transferCount) > 0
          ? `${screenRecFilename.slice(0, -5)}_${transferCount}${screenRecFilename.slice(-5)}`
          : screenRecFilename;

      console.log(
        "uploading screen recording... ",
        "filename: ",
        uploadFilename,
        "transferCount: ",
        transferCount,
        "isContinueTransfer: ",
        isContinueTransfer
      );

      formData.append("files", screenRecBlob, uploadFilename);

      if (transferCount && !isContinueTransfer) {
        formData.append("merge", true);
        formData.append("uniqueid", stateCall.UniqueID);
        formData.append("partcount", transferCount + 1);
      }

      try {
        const response = await uploadScreenRecording(formData);

        if (!response?.message?.includes("successfully")) {
          throw new Error(response?.error || "Upload failed");
        }

        await addScreenRecording({
          uniqueid: stateCall.UniqueID,
          screenrecmessageid: `${moment().format("YYYY/MM/DD")}/${uploadFilename}`,
        });

        toast.dismiss();
        toast.success("screen recording uploaded", { autoClose: 3000 });
        console.log("screen recording uploaded");
        setScreenRecBlob(null);
      } catch (error) {
        setScreenRecBlob(null);
        toast.dismiss();

        toast.error("Upload failed. Recording downloaded locally.", {
          autoClose: 5000,
        });

        console.error("Screen recording upload failed:", error);
      }
    };

    uploadRecording();
  }, [screenRecBlob, screenRecFilename]);

  useEffect(() => {
    // Ask for notification permission on load
    if (Notification.permission === "default") {
      Notification.requestPermission();
    }
  }, []);

  function sendDesktopNotification(isTransfer = false) {
    // If tab is inactive, show notification
    if (
      document.visibilityState === "hidden" &&
      Notification.permission === "granted"
    ) {
      const notification = new Notification("Incoming call", {
        body: isTransfer
          ? "Incoming transfer call!"
          : "You have a call waiting!",

        icon: LogoMoxcal32,
        requireInteraction: isTransfer ? false : true,
      });

      notification.onclick = () => window.focus();
    }
  }

  const fetchData = () => {
    if (hasMore) {
      setTimeout(() => {
        runapi(page, viewType, false, searchChat);
      }, 1000);
    }
  };
  const MfetchData = () => {
    if (mhasMore) {
      setTimeout(() => {
        dispatch(messageList(detailchat.ChatListID, Mpage, false));
      }, 100);
    }
  };
  const setReadChat = (chatID, session, number, source) => {
    dispatch(readchat(chatID, session, number, source));
  };
  const handleSelect = (chatID, notRead, session, number, isActive) => {
    let tempSource;

    // Check chat source from chatID
    if (String(chatID).charAt(0) === "t") {
      console.log("FB");
      tempSource = "FBCHAT";
    } else {
      tempSource = "WA";
    }

    setChatSource(tempSource);
    if (pageLocation !== "chat") changePage("chat");

    SetmKey(chatID);
    //dcChatListID to record previous detailchat's chatlistid
    let dcChatListID = detailchat?.ChatListID;
    if (dcChatListID === undefined) {
      dcChatListID = 0;
    }
    if (chatID === 0 || chatID !== dcChatListID) {
      //chatID 0 FOR NEW CHAT, set chatID = dcChatListID
      if (chatID === 0) {
        chatID = dcChatListID;
      }
      dispatch({ type: CLEAR_MESSAGE });
      if (notRead > 0) {
        setReadChat(chatID, session, number, tempSource);
      }
      setmhasMore(true);
      dispatch(messageList(chatID, 1));
      setRenderChat(true);
      setActiveChat(chatID);
      setFooterMsg(isActive);
      getBase64(null);
      // } else if (chatID === dcChatListID) {
      //   // Fix chat room not showing on mobile
      //   setRenderChat(true);
      //   setFooterMsg(isActive);
      //   setActiveChat(chatID);
      //   let e = document.getElementById("ID_Chatroom");
      //   if (e !== null) e.style.display = "flex";
    }
  };
  const runapi = (page, viewType, IsChanges, search) => {
    if (localStorage.getItem("token")) {
      // unused
      // dispatch(chatList(page, viewType, IsChanges, search));
    } else {
      console.log("no tokens?");
    }
  };

  const clearSearchChat = () => {
    setSearchChat("");
    typeSelect(viewType, childKey, "");
  };

  const typeSelect = (CurrviewType, ChildK, search) => {
    const prevChildK = ChildK;
    if (prevChildK !== ChildK) {
      SetChildKey((ChildK) => ChildK + 1);
    }
    SetChildKey(ChildK);
    if (CurrviewType !== viewType || search !== undefined) {
      dispatch({
        type: CLEAR_CHATLIST,
        payload: {
          chatListViewType: CurrviewType,
        },
      });
      sethasMore(true);
      setviewType(CurrviewType);
      runapi(1, CurrviewType, true, search === undefined ? searchChat : search);
      //IF CHANGING viewType, clear chat screen
      setRenderChat(false);
      setActiveChat("");
      if (CurrviewType === "active" || CurrviewType === "unassign")
        dispatch(getCountList());
    }
  };

  const textFormatter = (text) => {
    let string = text;
    // html formatter
    const htmlFormat = [
      { symbol: "*", tag: "b" },
      { symbol: "_", tag: "em" },
      { symbol: "~", tag: "del" },
      { symbol: "```", tag: "code" },
    ];

    htmlFormat.forEach(({ symbol, tag }) => {
      if (!string) return;
      const regex = new RegExp(`\\${symbol}([^${symbol}]*)\\${symbol}`);
      const match = string.match(regex);
      if (!match) {
        return;
      }

      // const regexfront = new RegExp(`.\\*(.*?)\\*(?!\\.)`);
      // const skip = string.match(regexfront);
      // if (!skip) {
      //   return string;
      // }
      // const match = string.match(regex);
      // if (!match) return;

      match.forEach((m) => {
        let formatted = m;
        for (let i = 0; i < 2; i++) {
          formatted = formatted.replace(symbol, `<${i > 0 ? "/" : ""}${tag}>`);
        }
        string = string.replace(m, formatted);
      });
    });
    return string;
  };

  const NavUnread = (name) => {
    if (name === "Assigned") {
      return notReadCountNav.TotalUnread > 0 ? (
        <div id="TotalUnread" className="Circle">
          {notReadCountNav.TotalUnread}
        </div>
      ) : (
        <div id="TotalUnread"></div>
      );
    } else if (name === "Unassigned") {
      return notReadCountNav.UnassignNotRead > 0 ? (
        <div id="UnassignNotRead" className="Circle">
          {notReadCountNav.UnassignNotRead}
        </div>
      ) : (
        <div id="UnassignNotRead"></div>
      );
    }
  };

  const confirmEndChat = (type, caseid, assignmentid, ISCode, ISCodeReason, remarks) => {
    let detailcontact = contact.find((x) => x.ChatListID === mKey);

    dispatch(
      endChat(
        mKey,
        detailchat?.Session ? detailchat.Session : "admin",
        detailchat,
        detailcontact,
        type,
        caseid,
        assignmentid,
        ISCode,
        ISCodeReason,
        chatSource,
        remarks,
      )
    );

    setRenderChat(false);
    setActiveChat("");
    setSelectedChat(null);
  };

  const toastId = useRef(null);
  const toastShow = useRef(true);

  async function GenerateNonPopUpFiles(mediaMsg, session) {
    if (mediaMsg.length === 0) return;

    let nonPoppables = [];
    if (Array.isArray(mediaMsg)) {
      mediaMsg.forEach((m) => {
        switch (m.type) {
          case "sticker":
          case "ptt":
            nonPoppables.push({
              RecordID: m.type + m.RecordID,
              FileName: m.FileName,
            });
            break;
          default:
            break;
        }
      });
    }
    let rawFileArray = await Promise.all(
      nonPoppables.map((s) =>
        getFileMedia(s.FileName, session).then((res) => ({
          s,
          res,
        }))
      )
    );
    rawFileArray.forEach((f) => {
      document.getElementById(f.s.RecordID).src = f.res.data;
    });
  }

  const NewMessageNotifClick = (data) => {
    if (data.detailchat) {
      handleSelect(
        data.detailchat.ChatListID,
        data.detailchat.NotReadCount,
        data.detailchat.Session,
        data.detailchat.MobileNo,
        true //IsActive
      );
    } else {
      handleSelect(
        data.thread_id,
        1,
        "facebook",
        0,
        true //IsActive
      );
    }
  };

  const notif = (dataShow, data) => {
    toastId.current = toast.info(dataShow, {
      autoClose: 3000,
      closeButton: false,
      onClose: closeToast,
      onOpen: openToast,
      pauseOnFocusLoss: false,
      onClick: () => NewMessageNotifClick(data),
    });
  };
  const notifAssigned = (dataShow) => {
    toastId.current = toast.info(dataShow, {
      autoClose: 3000,
      closeButton: false,
      onClose: closeToast,
      onOpen: openToast,
      pauseOnFocusLoss: false,
    });
  };
  const updateNotif = (dataShow) => {
    toast.update(toastId.current, {
      render: dataShow,
      type: toast.TYPE.INFO,
      autoClose: 3000,
      closeButton: null,
      onClose: closeToast,
      pauseOnFocusLoss: false,
    });
  };

  const closeToast = () => {
    toastShow.current = true;
  };
  const openToast = () => {
    toastShow.current = false;
  };

  const updateSocketDetailChatDependency = () => {
    if (socket.current.hasListeners("AutoEndSession"))
      socket.current.off("AutoEndSession");

    socket.current.on("AutoEndSession", (data) => {
      dispatch({
        type: ENDCHAT_AUTO,
        payload: { contact: data, curChatID: activeChat },
      });
      if (detailchat.ChatListID === data.ChatListID) {
        setRenderChat(false);
        setActiveChat("");
      }
    });
    if (socket.current.hasListeners("OtherEndChat"))
      socket.current.off("OtherEndChat");
    socket.current.on("OtherEndChat", (data) => {
      dispatch({
        type: ENDCHAT_SUCCESS,
        payload: {
          ChatListID: data.detailchat.ChatListID,
          detailchat: data.detailchat,
          contact: data.contact,
        },
      });
      if (detailchat.ChatListID === data.ChatListID) {
        setRenderChat(false);
        setActiveChat("");
      }
    });
  };

  const handleStopRinging = () => {
    // Stop ringtone and reset the current duration
    ringtone.pause();
    ringtone.currentTime = 0;
    setIsCallComing(false);
    setIsCallWaiting(false);
  };

  const newMessageNotification = (data, source) => {
    //audio is defined here so can be played w/o interacting with DOM element
    const audio = new Audio(NotificationSound);

    const limit = 30;

    if (source === "WA") {
      let stringContact = String(data.detailchat.ContactName);
      let stringMsg = String(data.detailchat.LastMessage);
      if (stringContact.length > limit)
        stringContact = stringContact.substring(0, limit) + "...";

      if (stringMsg.length > limit)
        stringMsg = stringMsg.substring(0, limit) + "...";

      let result = (
        <div>
          <div className="messageNotif">
            <h4> {stringContact}</h4>
          </div>
          <div className="messageNotif">
            <p> {stringMsg} </p>
            <span className="listChat_timeStamp">
              {moment.utc(data.detailchat.ReceiveTime).format("HH:mm")}
            </span>
          </div>
        </div>
      );

      let assigned = (
        <div>
          <div className="messageNotif">
            <h4> New message </h4>
          </div>
          <div className="messageNotif">
            <p>Sender : {stringContact}</p>
            <span className="listChat_timeStamp">
              {moment.utc(data.detailchat.ReceiveTime).format("HH:mm")}
            </span>
          </div>
        </div>
      );

      //level agent
      if (level === 0) {
        //notif for agent assigned
        if (data.OldAgent) {
          notifAssigned(assigned);
        } else if (!data.detailchat.FromMe && toastShow.current) {
          // sessionStorage.getItem("isNotificationsMuted") === "false" &&
            audio.play();

          notif(result, data);
        } else updateNotif(result, data);
      } else if (level > 0) {
        if (!data.detailchat.FromMe && toastShow.current) {
          // sessionStorage.getItem("isNotificationsMuted") === "false" &&
            audio.play();

          if (!data.OldAgent) {
            notif(result, data);
          }
        } else {
          updateNotif(result, data);
        }
      }
    } else {
      let result = (
        <div>
          <div className="messageNotif">
            <h4>
              {" "}
              {data.from.name.length > limit
                ? data.from.name.substring(0, limit) + "..."
                : data.from.name}
            </h4>
          </div>
          <div className="messageNotif">
            <p>
              {" "}
              {data.message.length > limit
                ? data.message.substring(0, limit) + "..."
                : data.message}{" "}
            </p>
            <span className="listChat_timeStamp">
              {moment.utc(data.created_time).format("HH:mm")}
            </span>
          </div>
        </div>
      );

      // sessionStorage.getItem("isNotificationsMuted") === "false" &&
        audio.play();

      notif(result, data);
    }
  };

  //SOCKET FOR SERVER-CLIENT CONNECTION
  useEffect(() => {
    if (initialPageLoaded.current) {
      return;
    }

    // Register SIP account
    function isEmpty(obj) {
      for (let x in obj) {
        return false;
      }
      return true;
    }

    if (!isEmpty(sipAccount)) {
      // Check if sipAccount object is empty
      let bytes = AES.decrypt(
        sipAccount,
        sipParam
      );

      let decryptedSipAccount = JSON.parse(bytes.toString(enc.Utf8));

      dispatch(
        registerSIP(
          decryptedSipAccount.webrtcUser,
          decryptedSipAccount.webrtcPass,
          decryptedSipAccount.displayName,
          decryptedSipAccount.websocketSIP,
          decryptedSipAccount.websocketURL,
          CurrentState,

          (audioStream) => {
            // This runs when remote audio stream is received
            if (remoteAudioRef.current) {
              remoteAudioRef.current.srcObject = audioStream;
            }
          },

          (videoStream) => {
            // This runs when remote video stream is received
            if (remoteVideoRef.current) {
              remoteVideoRef.current.srcObject = videoStream;
            }
          },

          (localStream) => {
            localMediaStreamRef.current = localStream;

            if (localVideoRef.current) {
              localVideoRef.current.srcObject = localStream;
            }
          }
        )
      );
    }

    socket.current = io(`${process.env.REACT_APP_SOCKET_URL}`);
    console.log("socket.current", socket.current);
    socket.current.on("connect", () => {
      if (socket.current.connected && socket.current.id)
        socket.current.emit("addUser", myInfo.user.AgentID, myInfo.user);
    });

    //currently has no use
    socket.current.on("disconnect", (reason) => {});

    // Logout user when access has been revoked
    socket.current.on("UNLOCKAGENT", (data) => {
      handleLogout();
      toast.info("Your access has been revoked", { autoClose: 3000 });
    });

    // Change agent status from supervisor
    socket.current.on("CHANGEAGENTSTATUS", (data) => {
      setSelection(data.reasoncode, true);

      toast.info(`Your status has been changed to ${data.reasoncode}`, {
        autoClose: 3000,
      });
    });

    socket.current.on("PHONEAPPROVAL", (data) => {
      console.log("PHONEAPPROVAL", data);

      if (data.Status === "APPROVE") {
        toast.success(
          `Update contact (${data.ContactName}) has been approved`,
          { autoClose: 3000 }
        );
      } else {
        toast.info(
          `Update contact (${data?.ContactName?.trim()}) has been rejected`,

          {
            autoClose: 3000,
          }
        );
      }
    });

    socket.current.on("StateCall", (data) => {
      console.log("StateCall", data);

      if (Number(data.StateCode) >= 16) {
        dispatch({
          type: UPDATE_STATECALL_RECEIVED_DATE,
          payload: data.receivedDate,
        });
      } else {
        dispatch({
          type: UPDATE_STATECALL,
          payload: data,
        });
      }

      if (data.StateCode === "5") {
        // Ringing
        dispatch(stateAction("BUSY", undefined, "READY", "Red"));
        localStorage.setItem("isInCall", "true");
      } else if (data.StateCode === "6") {
        // Up
        let ACWMode, ACWWaitTime;
        setScreenRecBlob(null);

        dispatch({
          type: SET_SCREEN_REC_FILENAME,
          payload: `scr_rec_${data.UniqueID}.webm`,
        });

        dispatch({
          type: SET_TRANSFER_COUNT,
          payload: data.TransferCount,
        });

        console.log(
          "screenRecFilename: ",
          `scr_rec_${data.UniqueID}${data.TransferCount ? "_" + data.TransferCount : ""}.webm`,
          "transferCount: ",
          transferCount
        );

        data.CallType === "INBOUND" &&
          getACDISPlan(data.ACDDeviceID)
            .then((response) => {
              if (response.status) {
                process.env.NODE_ENV === "development" &&
                  console.log("getACDISPlan", response.data[2][0]?.acwmode);

                ACWMode = response.data[2][0]?.acwmode;
                ACWWaitTime = response.data[2][0]?.maxiscodewaittime;
                localStorage.setItem("ACWMode", ACWMode);
                localStorage.setItem("ACWWaitTime", ACWWaitTime);

                // FIXTIME || NOACW || WAITISCODE
                (ACWMode === "FIXTIME" || ACWMode === "WAITISCODE") &&
                  dispatch({ type: SET_GO_TO_ACW, payload: true });
              } else {
                console.log("error", response.error);

                toast.error("Error getACDISPlan: " + response.error, {
                  autoClose: 3000,
                });
              }
            })
            .catch((err) => {
              console.log("err", err);

              toast.error("Error getACDISPlan: " + err, {
                autoClose: 3000,
              });
            });

        data.CallType !== "OUTBOUND" &&
          dispatch(stateAction("BUSY", undefined, "READY", "Red"));

        if (data.CallType === "INBOUND") {
          dispatch({ type: SET_IS_IN_CALL, payload: true });
          localStorage.setItem("isInCall", "true");
        }

        dispatch({
          type: UPDATE_CALL_STATE,
          payload: { stateCode: data.StateCode },
        });

        handleStopRinging();

        if (data.CallType === "AUTOMATICCALL") {
          dispatch({
            type: SET_DIAL_MODE,
            payload: "predictive",
          });

          dispatch({ type: SET_AUTO_DIAL, payload: true });

          dispatch({
            type: SET_CURRENT_ASSIGNMENT_ID,
            payload: { assignmentID: data.AssignmentID },
          });

          dispatch({ type: GET_ASSIGNMENT_DETAILS });

          dispatch({
            type: START_CALL,

            payload: {
              phoneNumber: data.PhoneNo,
              goToACW: true,
              type: "outbound",
              stateCode: data.StateCode,
              campaignID: data.CampaignID,
              phoneTypeID: data.PhoneTypeID,
              contactID: data.ContactID,
              isTelemarketing: data.isTSS,
            },
          });

          data.isTSS ? changePage("telemarketing") : changePage("campaign");
        } else {
          dispatch({
            type: UPDATE_CALL_STATE,
            payload: { stateCode: data.StateCode, phoneNumber: data.PhoneNo },
          });

          dispatch({
            type: CHECK_STRAY_CALL,

            payload: {
              goToACW:
                ACWMode === "FIXTIME" || ACWMode === "WAITISCODE"
                  ? true
                  : false,

              phoneTypeID: data.PhoneTypeID,
            },
          });
        }
      } else if (data.StateCode === "99") {
        // Hold
        console.log("description:", data.StateDescription);
      } else if (data.StateCode === "0" || Number(data.StateCode) >= 16) {
        // Normal Clearing
        getRecording(data.ActionID, data.UniqueID);
        dispatch(clearSessionCall());

        let ACWMode = localStorage.getItem("ACWMode"),
          ACWWaitTime = localStorage.getItem("ACWWaitTime");

        if (ACWMode === "FIXTIME" && ACWWaitTime) {
          setTimeout(() => {
            dispatch({ type: END_ACW });
            dispatch({ type: RESET_CALL_STATE });
            dispatch(stateAction("READY", undefined, "ACW", "Green"));
          }, ACWWaitTime * 1000);
        }

        localStorage.removeItem("ACWMode");
        localStorage.removeItem("ACWWaitTime");
      }

      if (data.IsTransfer) {
        ping.play(); // Add sound on incoming transfer
        setIsTransferCallComing(true);
        sendDesktopNotification(true);
        dispatch(stateAction("BUSY", undefined, "READY", "Red"));

        dispatch({
          type: START_CALL,

          payload: {
            contactID: data.ContactID,
            goToACW: data.GoToACW,
            phoneNumber: data.PhoneNo,
            stateCode: data.StateCode,
            type: data.CallType,
            campaignID: data.CampaignID,
            phoneTypeID: data.PhoneTypeID,
          },
        });

        if (data.CallType === "outbound" || data.CallType === "OUTBOUND") {
          changePage("campaign");
        }

        if (data.CallType === "inbound" || data.CallType === "INBOUND") {
          changePage("contact");
        }
      }

      if (data.IsConsult) {
        toast.info("Incoming consultation call", {
          autoClose: 3000,
        });

        dispatch({
          type: START_CALL,

          payload: {
            phoneNumber: data.PhoneNo,
            stateCode: data.StateCode,
          },
        });
      }
    });

    // For inbound call; Notify for incoming calls
    socket.current.on("NotifyCall", (data) => {
      console.log(
        "NotifyCall",
        data,
        "document.visibilityState: ",
        document.visibilityState,
        "Notification.permission: ",
        Notification.permission
      );

      if (data.CallType === "OUTBOUND") {
        dispatch({
          type: INCOMING_CALL,

          payload: {
            ACDDeviceName: data.ACDDeviceName,
            queueName: data.QueueName,
            ext: data.Ext,
            contactID: data.ContactID,
            phoneNumber: data.PhoneNo,
            phoneTypeID: data.PhoneTypeID !== 0 ? data.PhoneTypeID : null,
            type: "outbound",
          },
        });

        setIsCallComing(true);
        sendDesktopNotification();

        sessionStorage.getItem("isNotificationsMuted") === "false" &&
          ringtone.play();
      } else {
        if (data.StateCode === "100") {
          // Abandoned

          // Fix stray abandoned notification resetting call state
          if (localStorage.getItem("isInCall") !== "true") {
            console.log("abandoned");
            handleStopRinging();
            dispatch({ type: RESET_CALL_STATE });
          }
        } else {
          dispatch({
            type: INCOMING_CALL,
            payload: {
              ACDDeviceName: data.ACDDeviceName,
              queueName: data.QueueName,
              ext: data.Ext,
              contactID: data.ContactID,
              phoneNumber: data.PhoneNo,
              phoneTypeID: data.PhoneTypeID,
            },
          });

          setIsCallComing(true);
          sendDesktopNotification();

          // sessionStorage.getItem("isNotificationsMuted") === "false" &&
            ringtone.play();
        }
      }
    });

    // For inbound call; Notify for waiting calls
    socket.current.on("NotifyCallWaiting", (data) => {
      console.log("NotifyCallWaiting", data);

      dispatch({
        type: WAITING_CALL,
        payload: {
          callWaiting: data.CallWaiting,
          ACDDeviceName: data.DeviceName,
        },
      });

      setIsCallWaiting(true);

      // Play ping sound only when agent status is not busy
      if (
        JSON.parse(localStorage.getItem("agentStatus"))?.container !== "BUSY"
        // JSON.parse(localStorage.getItem("agentStatus"))?.container !== "BUSY" &&
        // sessionStorage.getItem("isNotificationsMuted") === "false"
      ) {
        ping.play();
      }
    });

    // For inbound call; return current agent state as callback
    socket.current.on("GetAgentState", (data, callback) => {
      console.log("GetAgentState", data);

      let payload = {
        ...data,
        AgentID: Number(data.AgentID),
        AgentState: JSON.parse(localStorage.getItem("agentStatus"))?.container,
      };

      console.log("payload: ", payload);
      callback(payload);
    });

    socket.current.on("UpdateAck", (data) => {
      dispatch({
        type: SET_NEWSTATUS,
        payload: {
          chatListID: data.ChatListID,
          statusID: data.StatusID,
          statusName: data.StatusName.toLowerCase(),
        },
      });
    });

    socket.current.on("NewMessage", (data) => {
      newMessageNotification(data, "WA");

      dispatch({
        type: RECEIVE_CHAT,
        payload: {
          contact: data.detailchat,
          message: data.chatmessage,
          pass: data.pass,
          curChatID: activeChat,
        },
      });

      // Refresh chat list and message list
      dispatch({ type: UPDATE_CHAT });

      if (detailchat.ChatListID === data.detailchat.ChatListID)
        GenerateNonPopUpFiles(data.chatmessage, data.detailchat.Session);
    });

    socket.current.on("NEWFACEBOOKMESSAGE", (payload) => {
      // if (
      //   localStorage.getItem("winPage") !== "chat" ||
      //   localStorage.getItem("selectedChatID") !== payload.thread_id
      // ) {
      //   newMessageNotification(payload, "FBCHAT");
      // }

      // Do not show toast message when the notification is the same as the selected chat list
      if (
        localStorage.getItem("winPage") === "chat" &&
        localStorage.getItem("selectedChatID") !== payload.id
      ) {
        toast.info(`New Facebook message: ${payload.message}`);
      } else if (localStorage.getItem("winPage") !== "chat") {
        toast.info(
          `New Facebook message from: ${payload.from.name}`
        );
      }

      // Refresh chat list and message list
      dispatch({
        type: UPDATE_CHAT_SINGLE,
        payload: { chatListID: payload.chatlistid, isNewChat: true },
      });
    });

    socket.current.on("AssignedChat", (data) => {
      dispatch({
        type: ENDASSIGNED_SUCCESS,
        payload: {
          ChatListID: data.detailchat.ChatListID,
          detailchat: data.detailchat,
        },
      });
      if (detailchat.ChatListID === data.ChatListID) {
        setRenderChat(false);
        setActiveChat("");
      }
    });

    socket.current.on("OtherReadChat", (ChatListID) => {
      dispatch({
        type: SET_NEWSTATUS,
        payload: {
          chatListID: ChatListID,
          statusID: 3,
          statusName: "viewed",
        },
      });
    });

    // Chat internal socket event listener
    socket.current.on("InternalChat", (payload) => {
      const chatStorage = JSON.parse(sessionStorage.getItem("chatInternal"));

      const newMessage = {
        id: payload.id,
        sender: payload.senderName,
        message: payload.message,
        time: payload.time,
        isBroadcast: payload.isbroadcast ? true : false,
      };

      const newChat = {
        id: payload.senderID,
        agentName: payload.senderName,
        time: payload.time,
        messages: [newMessage],
        isViewed: false,
      };

      // Check if chat storage already existed
      if (chatStorage) {
        // Check if chat already existed
        let index = chatStorage.findIndex(
          (chat) => chat.id === payload.senderID
        );

        // If chat already existed, push the new message and set isViewed to false
        if (index >= 0) {
          chatStorage[index].messages.push(newMessage);
          chatStorage[index].isViewed = false;
          // Else, create new chat
        } else {
          chatStorage.push(newChat);
        }

        // Update storage
        sessionStorage.setItem("chatInternal", JSON.stringify(chatStorage));
        // If chat storage doesn't exist, create it
      } else {
        sessionStorage.setItem("chatInternal", JSON.stringify([newChat]));
      }

      // Dispatch event, used to trigger re-renders
      window.dispatchEvent(new Event("updateChatInternal"));

      // if (sessionStorage.getItem("isNotificationsMuted") === "false") {
        ping.play();
      // }
    });

    // Chat internal update read status
    socket.current.on("InternalReadChat", (payload) => {
      const chatStorage = JSON.parse(sessionStorage.getItem("chatInternal"));
      let chatIndex = null;
      let messageIndex = null;

      // Search the message
      chatStorage.some((chat, index) => {
        chatIndex = index;

        messageIndex = chat.messages.findIndex(
          (message) => message.id === payload.messageID
        );

        // If found, stop searching
        return messageIndex >= 0 ? true : false;
      });

      // If message found, update the read status
      if (messageIndex >= 0) {
        chatStorage[chatIndex].messages[messageIndex].isRead = true;
      }

      // Update storage
      sessionStorage.setItem("chatInternal", JSON.stringify(chatStorage));

      // Dispatch event, used to trigger re-renders
      window.dispatchEvent(new Event("updateChatInternal"));
    });

    // Start live chat socket event listener
    socket.current.on("sendLiveChatMessage", () => {
      setIsTyping(false);
      dispatch({ type: UPDATE_CHAT });
    });

    socket.current.on("closeSession", () => {
      // Refresh chat list and message list
      dispatch({ type: UPDATE_CHAT });

      console.log("closed");
    });

    socket.current.on(
      "stopTyping",
      (data) => data.from === "customer" && setIsTyping(false)
    );

    socket.current.on(
      "typing",
      (data) => data.from === "customer" && setIsTyping(true)
    );
    // End live chat socket event listener

    socket.current.on(TICKET_CREATED, (payload) => {
      toast.info(payload.Message, {
        onClick: () => {
          dispatch({
            type: SET_SELECTED_TICKET_CASE_ID,
            payload: payload.RefNo,
          });

          changePage("ticket");
        },
      });
    });

    socket.current.on(TICKET_ESCALATED, (payload) => {
      toast.info(payload.Message, {
        onClick: () => {
          dispatch({
            type: SET_SELECTED_TICKET_CASE_ID,
            payload: payload.RefNo,
          });

          changePage("ticket");
        },
      });
    });

    socket.current.on(TICKET_MERGED, (payload) => {
      toast.info(payload.Message, {
        onClick: () => {
          dispatch({
            type: SET_SELECTED_TICKET_CASE_ID,
            payload: payload.RefNo,
          });

          changePage("ticket");
        },
      });
    });

    socket.current.on("IGMESSAGEDELETED", (payload) => {
      console.log("IGMESSAGEDELETED", payload);

      // Refresh chat list and message list
      dispatch({ type: UPDATE_CHAT });
    });

    socket.current.on("IGMESSAGEREAD", (payload) => {
      console.log("IGMESSAGEREAD", payload);

      // Refresh chat list and message list
      dispatch({ type: UPDATE_CHAT });
    });

    socket.current.on("IGNEWMESSAGE", (payload) => {
      console.log("IGNEWMESSAGE", payload);

      // Do not show toast message when the notification is the same as the selected chat list
      if (
        localStorage.getItem("winPage") === "chat" &&
        Number(localStorage.getItem("selectedChatID")) !== payload.chatlistid
      ) {
        toast.info(`New Instagram message: ${payload.text}`);
      } else if (localStorage.getItem("winPage") !== "chat") {
        toast.info(`New Instagram message: ${payload.text}`);
      }

      // Refresh chat list and message list
      dispatch({
        type: UPDATE_CHAT_SINGLE,
        payload: { chatListID: payload.chatlistid, isNewChat: true },
      });

      if (!isTabActive) {
        Push.create("New Instagram Message Received", {
          body: `Message: ${payload.text}`,
          icon: LogoMoxcal32,
          requireInteraction: true,
          tag: "newMessage",

          onClick: () => {
            window.focus();
            this.close();
          },
        });
      }
    });

    socket.current.on("WANEWMESSAGE", (payload) => {
      process.env.NODE_ENV === "development" &&
        console.log("WANEWMESSAGE", payload);

      // Do not show toast message when the notification is the same as the selected chat list
      if (
        localStorage.getItem("winPage") === "chat" &&
        Number(localStorage.getItem("selectedChatID")) !== payload.chatlistid
      ) {
        toast.info(`New Whatsapp Business message: ${payload.text}`);
      } else if (localStorage.getItem("winPage") !== "chat") {
        toast.info(`New Whatsapp Business message: ${payload.text}`);
      }

      // Refresh chat list and message list
      dispatch({
        type: UPDATE_CHAT_SINGLE,
        payload: { chatListID: payload.chatlistid, isNewChat: true },
      });

      if (!isTabActive) {
        Push.create("New Whatsapp Business Message Received", {
          body: `Message: ${payload.text}`,
          icon: LogoMoxcal32,
          requireInteraction: true,
          tag: "newMessage",

          onClick: () => {
            window.focus();
            this.close();
          },
        });
      }
    });

    socket.current.on("WAMESSAGESTATUS", (payload) => {
      process.env.NODE_ENV === "development" &&
        console.log("WAMESSAGESTATUS", payload);

      // Refresh chat list and message list
      dispatch({ type: UPDATE_CHAT_SINGLE });
    });

    socket.current.on("NEWCHATASSIGNMENT", () => {
      toast.info("A new message has been assigned", { autoClose: 3000 });

      // Refresh chat list and message list
      dispatch({ type: UPDATE_CHAT });
    });

    socket.current.on("CHATREASSIGNMENT", (payload) => {
      process.env.NODE_ENV === "development" &&
        console.log("CHATREASSIGNMENT", payload);

      toast.info("Your message has been reassigned to other agent", {
        autoClose: 3000,
      });

      // Refresh chat list and message list
      dispatch({ type: UPDATE_CHAT });
    });

    socket.current.on("CHATCLOSINGASSIGNMENT", (payload) => {
      process.env.NODE_ENV === "development" &&
        console.log("CHATCLOSINGASSIGNMENT", payload);

      toast.info("Your message has been resolved by other agent", {
        autoClose: 3000,
      });

      // Refresh chat list and message list
      dispatch({ type: UPDATE_CHAT });
    });

    socket.current.on("NEWEMAILASSIGNMENT", () => {
      toast.info("A new email has been assigned", { autoClose: 3000 });

      // Refresh chat list and message list
      dispatch({ type: UPDATE_EMAIL });
    });

    socket.current.on("EMAILREASSIGNMENT", (payload) => {
      process.env.NODE_ENV === "development" &&
        console.log("EMAILREASSIGNMENT", payload);

      toast.info("Your email has been reassigned to other agent", {
        autoClose: 3000,
      });

      // Refresh chat list and message list
      dispatch({ type: UPDATE_EMAIL });
    });

    updateSocketDetailChatDependency();

    // socket.current.emit("addUser", myInfo.user.AgentID, myInfo.user);
    fetchData();
    dispatch(getCountList());

    initialPageLoaded.current = true;

    if (!isApp()) {
      agentState()
        .then((response) => {
          if (response.status) {
            setStateOptions(response.data);
          } else {
            toast.warn(response.error);
          }
        })
        .catch((err) => {
          toast.warn(err);
        });
    }

    //local Tab ID identifier
    let sessionTabID = sessionStorage.getItem("tabId");
    let localTabID = localStorage.getItem("tabId");
    if (!sessionTabID) {
      sessionStorage.setItem("tabId", Math.floor(Math.random() * 1000000));
    }
    if (!localTabID) {
      localStorage.setItem("tabId", sessionStorage.getItem("tabId"));
    }

    function clearLocalStorage(event) {
      if (event.data.delete && isApp()) localStorage.clear();
    }

    window.addEventListener("message", clearLocalStorage);
    return () => {
      window.removeEventListener("message", clearLocalStorage);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    updateSocketDetailChatDependency();
  }, [detailchat]);

  useEffect(() => {
    let assigned = document.getElementById("TotalUnread");
    if (assigned && notReadCountNav.TotalUnread > 0)
      assigned.innerText = notReadCountNav.TotalUnread;
    //notReadCountNav.TotalUnread

    let unassigned = document.getElementById("UnassignNotRead");
    if (unassigned && notReadCountNav.UnassignNotRead > 0)
      unassigned.innerText = notReadCountNav.UnassignNotRead;
    //notReadCountNav.UnassignNotRead
  }, [notReadCountNav]);

  useEffect(() => {
    if (Object.keys(emitCode).length === 0) return;

    switch (emitCode.code) {
      case "readchat":
        socket.current.emit("EmitReadChat", {
          senderId: myInfo.user.AgentID,
          chatlistid: emitCode.ChatListID,
        });
        break;
      case "endchat":
        let data = {
          detailchat: emitCode.detailchat,
          contact: emitCode.contact,
        };
        socket.current.emit("EmitEndChat", {
          senderId: myInfo.user.AgentID,
          detailchat: data,
        });
        break;

      default:
        break;
    }
  }, [emitCode]);

  useEffect(() => {
    //After sending new chat, move to the chat room of the new chat
    if (
      detailchat !== undefined &&
      !isNaN(plChatListID) &&
      plChatListID.toString().length > 0
    ) {
      if (plChatListID === 0 && chatListViewType === "close") {
        setActive(level > 0 ? 1 : 0);
        typeSelect("active", 0);
      }
      handleSelect(
        plChatListID,
        detailchat.NotReadCount,
        detailchat.Session,
        detailchat.MobileNo,
        true //IsActive
      );
    }
  }, [plChatListID]);

  //---------------------------------------------- PageStateStart---------------------------------------------//
  useEffect(() => {
    const setWindowPage = (data) => {
      if (!data) window.localStorage.removeItem("winPage");
      else window.localStorage.setItem("winPage", data);
    };
    setWindowPage(pageLocation);
  }, [pageLocation]);
  //---------------------------------------------- PageStateEnd---------------------------------------------//

  //---------------------------------------------- AgentStatusStart---------------------------------------------//
  const [status, setStatus] = useState("");
  const [stateOptions, setStateOptions] = useState([]);
  const [changeColor, setchangeColor] = useState("");
  const [ChangeCompletePass, setChangeCompletePass] = useState(false);

  const handleChange = (event) => {
    setSelection(event.target.value);
  };

  const setSelection = (color, isFromChangeAgentStatus = false) => {
    const splitReasonCode = color.split(" - ");
    const statusState = splitReasonCode[0];
    const statusReason = splitReasonCode[1];
    let colors = stateOptions.find((x) => x.ReasonCode === color)?.Color;
    let lastStatus = JSON.parse(localStorage.getItem("agentStatus"))?.container;

    if (!colors) {
      colors = CurrentColor ? CurrentColor : "Green";
    }

    // If is in auto dial, wait until current assignment is saved. Also check for statusReason to determine whether the selection is made from the user or not
    if (isInAutoDial && statusReason) {
      dispatch({ type: SET_PENDING_STATUS_REASON, payload: statusReason });
    } else {
      dispatch(
        stateAction(
          statusState,
          statusReason,
          isFromChangeAgentStatus ? lastStatus : status,
          colors
        )
      );
    }
  };

  useEffect(() => {
    if (stateOptions.length > 0) {
      let state = CurrentState ? CurrentState : "NOT BOUND";

      if (CurrentColor && CurrentState) {
        if (CurrentColor === "Green") {
          setchangeColor("BGcolor1");
        } else if (CurrentColor === "Orange") {
          setchangeColor("BGcolor2");
        } else if (CurrentColor === "DarkRed") {
          setchangeColor("BGcolor3");
        } else if (CurrentColor === "Red") {
          setchangeColor("BGcolor4");
        } else if (CurrentColor === "Yellow") {
          setchangeColor("BGcolor5");
        }

        setStatus(state);
      } else {
        setStatus(state);
        setchangeColor("BGcolor3");
      }
    }

    if (errorMessageAuth) {
      // toast.warn(errorMessageAuth);
      dispatch({ type: ERROR_CLEARALL });
    }
    if (successMessageAuth) {
      toast.success(successMessageAuth);
      setChangeCompletePass(true);
      setTimeout(() => {
        setChangeCompletePass(false);
      }, 1000);
      dispatch({ type: SUCCESS_MESSAGE_CLEAR });
    }
  }, [
    CurrentColor,
    CurrentState,
    errorMessageAuth,
    successMessageAuth,
    stateOptions,
  ]);

  const AgentModalButton = (value) => {
    dispatch(setAssignedAgent(detailchat.ChatListID, value.AgentID));
  };
  //---------------------------------------------- AgentStatusEnd---------------------------------------------//
  const origin = "test";
  const pageToShow = () => {
    switch (pageLocation) {
      case "monitoring":
        return <Monitoring />;
      case "contact":
        return (
          <Contact
            changePage={changePage}
            setIsBroadcastContactShown={setIsBroadcastContactShown}
          />
        );
      case "DashboardInbound":
        return <Dashboard changePage={changePage} />;
      case "DashboardOutbound":
        return <DashboardOutbound />;
      case "DashboardSocMed":
        return <DashboardSocmed />;
      case "DashboardTelemarketing":
        return <DashboardTSS />;
      case "DashboardWABA":
        return <DashboardWhatsapp />;
      case "DashboardTicket":
        return <DashboardTicket />;
      case "DashboardInteraction":
        return <DashboardInteraction />;
      case "DashboardWABAv2":
        return <DashboardWhatsappInsights />;
      case "callHistory":
        return <CallHistory isApp={app} level={level} />;
      case "notification":
        return <NotificationPage changePage={changePage} />;
      case "ticket":
        return (
          <Ticket
            changePage={changePage}
            GenerateNonPopUpFiles={GenerateNonPopUpFiles}
          />
        );
      case "campaign":
        return (
          <Campaign
            changePage={changePage}
            GenerateNonPopUpFiles={GenerateNonPopUpFiles}
          />
        );
      case "telemarketing":
        return <Telemarketing GenerateNonPopUpFiles={GenerateNonPopUpFiles} />;
      case "QAOutbound":
        return <QualityAssurance />;
      case "QATelemarketing":
        return (
          <QualityAssurance
            isTelemarketing
            GenerateNonPopUpFiles={GenerateNonPopUpFiles}
          />
        );
      case "QAInbound":
        return <QualityAssurance isInbound />;
      case "mailHistory":
        return <Email />;
      case "chat":
        return (
          <div className="WholeChat">
            <div className="listMain">
              <div className="list_header_chat">
                <div className="list_headerLeft">
                  <h1>Messages</h1>
                </div>

                <div className="list_headerRight">
                  <Tooltip title="Messages menu" arrow>
                    <IconButton
                      onClick={(event) => {
                        setAnchorElMore(event.currentTarget);
                      }}
                      aria-controls={open ? "Message_action" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                    >
                      <MoreVertIcon />
                    </IconButton>
                  </Tooltip>

                  <Menu
                    anchorEl={anchorElMore}
                    className="messages-menu"
                    id="Message_action"
                    open={openMore}
                    onClose={() => setAnchorElMore(null)}
                    onClick={() => setAnchorElMore(null)}
                    transformOrigin={{ horizontal: "right", vertical: "top" }}
                    anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                  >
                    <MenuItem
                      onClick={() => {
                        setOpenModal(true);
                        setIsFromNewChatButton(true);
                      }}
                    >
                      <ListItemIcon>
                        <Icon height="30" icon="mdi:message-plus-outline" />
                      </ListItemIcon>
                      New Message
                    </MenuItem>

                    <MenuItem onClick={() => setIsBroadcastContactShown(true)}>
                      <ListItemIcon>
                        <Icon
                          height="30"
                          icon="fluent:megaphone-loud-16-regular"
                        />
                      </ListItemIcon>
                      Broadcast
                    </MenuItem>

                    <MenuItem onClick={() => setIsAssigningChats(true)}>
                      <ListItemIcon>
                        <Icon height="30" icon="mdi:message-check-outline" />
                      </ListItemIcon>
                      Assign Chats
                    </MenuItem>
                  </Menu>

                  {openModal ? (
                    <NewChat
                      sendMessage={sendMessage}
                      parentMsgParam={msgParam}
                      // readchat={setReadChat}
                      setOpenModal={setOpenModal}
                      agentID={myInfo.user.AgentID}
                      isSendingCallPermissionRequest={
                        isSendingCallPermissionRequest
                      }
                      setIsSendingCallPermissionRequest={
                        setIsSendingCallPermissionRequest
                      }
                      recipientPhoneNo={selectedChat?.WAID}
                      WABAAccountID={selectedChat?.WABAAccountID}
                      isFromNewChatButton={isFromNewChatButton}
                      setIsFromNewChatButton={setIsFromNewChatButton}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <div className="chat-list-container">
                <ChatList
                  handleSelect={handleSelect}
                  isAssigningChats={isAssigningChats}
                  joinLiveChat={joinLiveChat}
                  selectedChat={selectedChat}
                  setSelectedChat={setSelectedChat}
                  setIsAssigningChats={setIsAssigningChats}
                  setIsBack={setIsBack}
                />
              </div>
            </div>

            <LandingChat />

            {/* {renderChat ? ( */}

            {selectedChat ? (
              selectedChat.ChatSource === "WA" ? (
                <ChatRoomOld
                  key={mKey}
                  contact={contact}
                  detailchat={detailchat}
                  message={message}
                  myInfo={myInfo}
                  MfetchData={MfetchData}
                  mhasMore={mhasMore}
                  sendMessage={sendMessage}
                  msgParam={msgParam}
                  footerMsg={selectedChat.IsActive}
                  getBase64={getBase64}
                  file64={file64}
                  confirmEndChat={confirmEndChat}
                  readchat={setReadChat}
                  GenerateNonPopUpFiles={GenerateNonPopUpFiles}
                  isApp={isApp}
                  viewType={viewType}
                  AgentModalButton={AgentModalButton}
                  selectedChat={selectedChat}
                />
              ) : (
                <ChatRoom
                  AgentModalButton={AgentModalButton}
                  changePage={changePage}
                  confirmEndChat={confirmEndChat}
                  selectedChat={selectedChat}
                  setSelectedChat={setSelectedChat}
                  isBack={isBack}
                  setIsBack={setIsBack}
                  setOpenModalCallPermission={setOpenModalCallPermission}
                  handleMessageInputChange={handleMessageInputChange}
                  isTyping={isTyping}
                />
              )
            ) : (
              ""
            )}
            {/* <ChatRoomFB
                  key={mKey}
                  chatListID={mKey}
                  contact={contact}
                  selectedChat={contact.find(
                    (contact) => contact.ChatListID === mKey
                  )}
                  detailchat={detailchat}
                  message={message}
                  myInfo={myInfo}
                  MfetchData={MfetchData}
                  mhasMore={mhasMore}
                  sendMessage={sendMessage}
                  msgParam={msgParam}
                  footerMsg={footerMsg}
                  getBase64={getBase64}
                  file64={file64}
                  confirmEndChat={confirmEndChat}
                  readchat={setReadChat}
                  GenerateNonPopUpFiles={GenerateNonPopUpFiles}
                  isApp={isApp}
                  viewType={viewType}
                  AgentModalButton={AgentModalButton}
                  socket={socket}
                /> */}
          </div>
        );
      case "fieldCollection":
        return <FieldCollection changePage={changePage} />;
      case "Production":
        return <Production GenerateNonPopUpFiles={GenerateNonPopUpFiles} />;
      case "Extract Sales":
        return <ExtractSales />;
      default:
        return <LandingChat origin={origin} />;
    }
  };

  useEffect(() => {
    if (page > max) {
      sethasMore(false);
    }
    if (Mpage > Mmax) {
      setmhasMore(false);
    }
    if (errorMessage) {
      toast.warn(errorMessage);
      dispatch({ type: SET_ERROR_CLEAR });
    } else if (successMessage) {
      toast.success(successMessage);
      dispatch({ type: SET_SUCCESS_CLEAR });
    }
  }, [page, Mpage, errorMessage, successMessage]);

  const sendMessage = (childMsgParam) => {
    dispatch(
      sendChat(
        childMsgParam.contactname,
        childMsgParam.newchat,
        childMsgParam.number,
        childMsgParam.session,
        childMsgParam.type,
        childMsgParam.message,
        childMsgParam.caption,
        childMsgParam.filename,
        childMsgParam.curChatID // curChatID if newchat always 0
      )
    );

    setFile64({ name: null, base64: null, type: null });
  };

  const handleLogout = async (e) => {
    socket.current.emit("logout", myInfo.user.AgentID);

    if (localStorage.getItem("token")) {
      if (e !== undefined) e.preventDefault();
      dispatch(userLogout());
      dispatch({ type: CLEAR_CHATSTATE });
      dispatch({ type: SET_LOGOUT_CLEAR });
      dispatch({ type: RESET_AGENT_STATE });
      dispatch(clearSessionCall("logout"));
      dispatch({ type: RESET_CALL_STATE });
      console.log("CurrentState:", CurrentState);
      dispatch(stateAction("LOGGEDOFF", "", CurrentState));
      dispatch(unregisterSIP());
    }
  };

  const changePage = (page) => {
    if (page === "chat") {
      typeSelect(viewType, childKey, "");
    }

    // Reset assignment ID when leaving campaign page
    if (page !== "campaign") {
      dispatch({
        type: SET_CALL_SCHEDULE_ASSIGNMENT_ID,
        payload: null,
      });
    }

    // Reset isSelectingContact state when leaving contact page
    if (page !== "contact" && page !== "chat") {
      dispatch({
        type: SET_IS_SELECTING_CONTACT,
        payload: false,
      });
    }

    // Reset ticket tablePage state
    dispatch({
      type: SET_TABLE_PAGE,
      payload: { tablePage: 0 },
    });

    setPageLocation(page);
  };

  const getBase64 = (file) => {
    if (file === null) {
      setFile64({ name: null, base64: null, type: null });
      return;
    }
    //ini max 3mb
    if (file.size >= 3 * 1024 * 1024) {
      toast.warn("File Size cannot exceed 3MB!");
      return;
    }
    document.body.style.cursor = "wait";

    //"video/mp4"
    let filetype = file.type.substr(0, file.type.indexOf("/"));

    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setFile64({ name: file.name, base64: reader.result, type: filetype });
      document.body.style.cursor = "default";
    };
    reader.onerror = function (error) {
      setFile64({ name: null, base64: null, type: null });
      document.body.style.cursor = "default";
    };
  };

  const [searchChat, setSearchChat] = useState("");
  const [searchContain, setSearchContain] = useState(false);
  useEffect(() => {
    const searchRegex = /^./;
    const result = searchRegex.test(searchChat);
    setSearchContain(result);
  }, [searchChat]);

  // Logout user when page is reloaded or tab closed (only runs in production mode)
  useEffect(() => {
    if (
      localStorage.getItem("isNotFirstLoad") &&
      process.env.NODE_ENV === "production"
    ) {
      localStorage.removeItem("isNotFirstLoad");

      setTimeout(() => {
        handleLogout();
      }, 200);
    } else {
      localStorage.setItem("isNotFirstLoad", true);
    }
  }, []);

  function joinLiveChat(sessionID) {
    socket.current.emit("startLiveChatSession", sessionID);
  }

  // debounce stop typing
  let typingTimeout;

  function debounceStopTyping(sessionID) {
    clearTimeout(typingTimeout);

    typingTimeout = setTimeout(() => {
      socket.current.emit("stopTyping", {
        from: "agent",
        sessionID: sessionID,
      });
    }, 1500);
  }

  function handleMessageInputChange(sessionID) {
    socket.current.emit("typing", { from: "agent", sessionID: sessionID });
    debounceStopTyping(sessionID);
  }

  function handleAnswerCall() {
    if (isCallComing) {
      handleStopRinging();

      answerCall(queueName, ext)
        .then((response) => {
          if (response.status) {
            console.log("Answer call: ", response.data);
            dispatch({
              type: START_CALL,

              payload: {
                phoneNumber: phoneNumber,
                phoneTypeID: phoneTypeID,
                // goToACW: true,
                type: "inbound",
              },
            });

            // dispatch(stateAction("BUSY", undefined, "READY", "Red"));
          } else {
            console.log("error", response.error);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });

      changePage("contact");
    }
  }

  // Check operational hours and window visibility for call auto answer
  function checkSnackbarAutoHideCondition() {
    const startHour = moment().hour(7);
    const endHour = moment().hour(22);

    if (
      !moment().isBetween(startHour, endHour) ||
      document.visibilityState === "hidden" ||
      type === "OUTBOUND"
    ) {
      return null;
    } else {
      return 5000;
    }
  }

  async function handlePictureInPicture() {
    const video = remoteVideoRef.current;
    if (!video) return;

    try {
      if (document.pictureInPictureElement === video) {
        await document.exitPictureInPicture();
      } else if (document.pictureInPictureEnabled) {
        await video.requestPictureInPicture();
      }
    } catch (err) {
      console.error("PiP error:", err);
    }
  }

  return (
    <div className="chat" id="chatId">
      <CallOverlay />
      <CallControl changePage={changePage} />
      <ContinueAutoDial changePage={changePage} />

      <audio autoPlay ref={remoteAudioRef} style={{ display: "none" }} />

      <div
        className={`video-call ${inAppCallType === "video" ? "in-call" : ""}`}
        // className={`video-call in-call`}
      >
        <div className="video-call-container">
          <div className="buttons">
            <Tooltip
              arrow
              title={isVideoCallMinimized ? "Maximize" : "Minimize"}
            >
              <IconButton
                onClick={() => setIsVideoCallMinimized(!isVideoCallMinimized)}
              >
                <Icon
                  height="32"
                  icon={`prime:window-${isVideoCallMinimized ? "maximize" : "minimize"}`}
                  width="32"
                />
              </IconButton>
            </Tooltip>

            <Tooltip arrow title="Open picture-in-picture">
              <IconButton onClick={handlePictureInPicture}>
                <Icon
                  height="32"
                  icon="ic:round-picture-in-picture"
                  width="32"
                />
              </IconButton>
            </Tooltip>
          </div>

          <video
            autoPlay
            className={`customer-video ${isVideoCallMinimized ? "minimized" : ""} ${scaleClass}`}
            controls={false}
            loop
            playsInline
            ref={remoteVideoRef}
            // src="https://placeholdervideo.dev/240x320"
          />

          <video
            autoPlay
            className="agent-video"
            controls={false}
            muted
            playsInline
            ref={localVideoRef}
            // src="https://placeholdervideo.dev/320x240"
          />

          <section className="controls">
            <Tooltip title={onHold ? "Resume" : "Hold"} arrow>
              <IconButton
                sx={{
                  width: "3rem",
                  height: "3rem",
                  bgcolor: onHold ? "#FFF" : "#9b9b9b",
                  color: onHold ? "#9b9b9b" : "#FFF",
                  boxShadow: "0px 2px 18px 1px rgba(0, 0, 0, 0.18)",

                  "&:hover": {
                    backgroundColor: onHold ? "#c4c4c4" : "#848484",
                  },
                }}
                onClick={() => dispatch(holdCall())}
              >
                <PhonePaused />
              </IconButton>
            </Tooltip>

            <Tooltip
              title={inAppCallStatus === "started" ? "End call" : "Reload page"}
              arrow
            >
              <IconButton
                disabled={onHold}
                sx={{
                  width: "4rem",
                  height: "4rem",
                  bgcolor: "#F24E1E",
                  color: "#FFF",
                  boxShadow: "0px 2px 18px 1px rgba(0, 0, 0, 0.18)",

                  "&:hover": {
                    backgroundColor: "#ff7d58",
                  },
                }}
                onClick={() => dispatch(clearSessionCall())}
              >
                <CallEnd fontSize="large" />
              </IconButton>
            </Tooltip>

            <Tooltip title={isMuted ? "Unmute" : "Mute"} arrow>
              <IconButton
                sx={{
                  width: "3rem",
                  height: "3rem",
                  bgcolor: "#9b9b9b",
                  color: "#FFF",
                  boxShadow: "0px 2px 18px 1px rgba(0, 0, 0, 0.18)",
                  "&:hover": { backgroundColor: "#848484" },
                }}
                disabled={onHold}
                onClick={() => dispatch(muteCall())}
              >
                {isMuted ? <Mic /> : <MicOff />}
              </IconButton>
            </Tooltip>
          </section>
        </div>
      </div>

      {/* Incoming call notification */}
      <Snackbar
        anchorOrigin={{
          horizontal: "right",
          vertical: "bottom",
        }}
        open={isCallComing}
        TransitionComponent={slideTransition}
        autoHideDuration={checkSnackbarAutoHideCondition()}
        onClose={(event, reason) => {
          // Ignore clickaway and escape button presses
          if (reason === "clickaway" || reason === "escapeKeyDown") return;

          setIsCallWaiting(false);
          setIsCallComing(false);
          type !== "OUTBOUND" && handleAnswerCall();
        }}
      >
        <div className="incoming-call-snackbar">
          <header className="incoming">
            <Icon height="28" icon="ion:warning" width="28" />

            <p>Incoming Call</p>

            <Icon height="28" icon="ion:warning" width="28" />
          </header>

          <div className="snackbar-content">
            <p>You Have a Call Waiting!</p>

            <p className="acd-name">
              {type === "outbound" ? "Predictive Dial" : ACDDeviceName}
            </p>

            <Button
              disabled={type === "outbound"}
              variant="contained"
              onClick={handleAnswerCall}
            >
              {type === "outbound" ? "Auto Answer" : "Answer"}
            </Button>
          </div>
        </div>
      </Snackbar>

      {/* Waiting call notification */}
      <Snackbar
        anchorOrigin={{
          horizontal: "right",
          vertical: "bottom",
        }}
        autoHideDuration={5000}
        disableWindowBlurListener
        open={!isCallComing && isCallWaiting}
        TransitionComponent={Fade}
        onClose={(event, reason) => {
          // Ignore clickaway and escape button presses
          if (reason === "clickaway" || reason === "escapeKeyDown") return;
          setIsCallWaiting(false);
        }}
      >
        <div className="incoming-call-snackbar">
          <header className="waiting">
            <Icon height="28" icon="ion:warning" width="28" />

            <p>Waiting Call</p>

            <Icon height="28" icon="ion:warning" width="28" />
          </header>

          <div className="snackbar-content">
            <p>{callWaiting} Call(s) Waiting!</p>
            <p className="acd-name">{ACDDeviceName}</p>
          </div>
        </div>
      </Snackbar>

      {/* Transfer call notification */}
      <Snackbar
        anchorOrigin={{
          horizontal: "right",
          vertical: "bottom",
        }}
        autoHideDuration={5000}
        disableWindowBlurListener
        open={isTransferCallComing}
        TransitionComponent={Fade}
        onClose={(event, reason) => {
          // Ignore clickaway and escape button presses
          if (reason === "clickaway" || reason === "escapeKeyDown") return;
          setIsTransferCallComing(false);
        }}
      >
        <div className="incoming-call-snackbar">
          <header className="incoming">
            <Icon height="28" icon="ion:warning" width="28" />

            <p>Incoming Transfer Call</p>

            <Icon height="28" icon="ion:warning" width="28" />
          </header>

          <div className="snackbar-content">
            <p>Incoming Transfer Call!</p>
          </div>
        </div>
      </Snackbar>

      <BroadcastContact
        isOpen={isBroadcastContactShown}
        setIsBroadcastContactShown={setIsBroadcastContactShown}
      />
      <Navbarbar
        myInfo={myInfo}
        handleChange={handleChange}
        changeColor={changeColor}
        handleLogout={handleLogout}
        changePage={changePage}
        stateOptions={stateOptions}
        status={status}
        ChangeCompletePass={ChangeCompletePass}
        pageLocation={pageLocation}
      />
      <ErrorBoundary fallbackRender={() => navigate("/error")}>
        {pageToShow()}
      </ErrorBoundary>

      {openModalCallPermission ? (
        <CallPermissionModal
          contactID={selectedChat.ContactID}
          recipientPhoneNo={selectedChat.WAID}
          WABAAccountID={selectedChat.WABAAccountID}
          onClose={() => setOpenModalCallPermission(false)}
          setIsSendingCallPermissionRequest={setIsSendingCallPermissionRequest}
          setOpenModalCallPermission={setOpenModalCallPermission}
          setOpenModalNewChat={setOpenModal}
        />
      ) : (
        ""
      )}
    </div>
  );
}
